import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../locale/en.json";
import hi from "../locale/hi.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      hi: {
        translation: hi,
      },
    },
    // lng: "hi",
    fallbackLng: "en",
    // React already escapes everything it renders, so i18next must NOT escape interpolated values
    // too: with its default (escapeValue: true) a value like "it's" or "A & B" reached the screen as
    // "it&#39;s" / "A &amp; B" (e.g. the PDP scarcity line, whose {{subtitle}} is a translated
    // string). Safe here: no interpolated t()/Trans output is ever fed to dangerouslySetInnerHTML
    // (checked 2026-10-15 -- the only translated innerHTML, returnToShopSheet.title and the policy
    // pages, take no values).
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });
